import React from 'react';

const Home = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-forest-green to-moss-green text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
          <div className="text-center">
            <h1 className="text-5xl md:text-7xl font-bold mb-6">
              Adventure Awaits. Pets Included.
            </h1>
            <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
              Every adventure is better with your pet.
            </p>
            <div className="text-6xl mb-8">
              🐾
            </div>
          </div>
        </div>
      </div>

      {/* Intro Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-lg shadow-lg p-8 md:p-12">
          <h2 className="text-3xl md:text-4xl font-bold text-forest-green mb-6 text-center">
            Welcome to NorthPet Inc.
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed text-center max-w-4xl mx-auto">
            At NorthPet, we believe pets are family, and they should be part of every fun moment, 
            trip, or daily walk. We're here to help make those moments even better. Whether you're 
            exploring the great outdoors or enjoying a stroll around the neighborhood, we provide 
            the gear and supplies to keep your pet comfortable, safe, and ready for adventure.
          </p>
        </div>
      </div>

      {/* Features Section */}
      <div className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-forest-green mb-12 text-center">
            Why Choose NorthPet?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-lg shadow-md text-center">
              <div className="text-5xl mb-4">🌲</div>
              <h3 className="text-xl font-bold text-forest-green mb-3">Nature-Inspired</h3>
              <p className="text-gray-600">
                Our products are designed for outdoor adventures and nature-loving pet owners.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md text-center">
              <div className="text-5xl mb-4">♻️</div>
              <h3 className="text-xl font-bold text-forest-green mb-3">Eco-Conscious</h3>
              <p className="text-gray-600">
                We're committed to sustainable practices and environmentally friendly materials.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md text-center">
              <div className="text-5xl mb-4">❤️</div>
              <h3 className="text-xl font-bold text-forest-green mb-3">Pet Family</h3>
              <p className="text-gray-600">
                We treat pets like family because that's exactly what they are to us.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
